import { useAppSelector, useAppDispatch } from "@/services/hooks";
import React, { useEffect, useMemo } from "react";

import { getSettingVariablesToUpdate } from "@/services/siteServices/siteActions";
import { ensureContactEmailVariable } from "@/utils/siteSettings";
import SiteConfigurationView from "./SiteConfigurationView";

// SCRUM-1225: this used to also dispatch getSettingVariables() and thread the
// resulting design-level catalogue (SettingsRequired / SettingsOptional) down to
// AddSiteConfigurationsContainer, which destructured it and never read it. The
// list a site actually edits is SettingsVariables below; adding one is free text.
const SiteConfigurationContainer = () => {
  const dispatch = useAppDispatch();
  const sitesSlice = useAppSelector((s) => s.sites);
  const { SettingsVariables = [] } = sitesSlice;

  useEffect(() => {
    dispatch(getSettingVariablesToUpdate());
  }, [dispatch]);

  const settingsVariables = useMemo(
    () => ensureContactEmailVariable(SettingsVariables),
    [SettingsVariables]
  );

  const current = useMemo(
    () => (typeof window !== "undefined" ? window.location.origin : ""),
    []
  );

  return (
    <SiteConfigurationView
      action="update"
      SettingsVariables={settingsVariables}
      current={current}
    />
  );
};

export default SiteConfigurationContainer;
